import { createAction, props } from '@ngrx/store';
import { Opportunity } from '@shared/models/opportunity';

export const updateOpportunity = createAction(
  '[Opportunities] Update Opportunity',
  props<{ opportunity: Partial<Opportunity> }>(),
);

export const updateOpportunitySuccess = createAction(
  '[Opportunities] Update Opportunity Success',
  props<{ opportunity: Opportunity }>(),
);

export const updateOpportunityFailure = createAction(
  '[Opportunities] Update Opportunity Failure',
  props<{ error: any }>(),
);
